import { request } from '../request';

/**
 * GET 获取我的个人认证资料和状态
 *
 * HTTP 接口: GET /subjects/personal/certification
 * 说明: 用于获取当前登录账号的个人实名认证申请状态、真实姓名、证件号码、证件正反面照片资源及联系人信息。
 *
 * @returns {Promise<Api.PersonalCertification.PersonalCertificationDetailResponse>} 返回个人认证详情响应对象 (partydto.PersonalCertificationDetailResponse)
 */
export function fetchGetPersonalCertification() {
  return request<Api.PersonalCertification.PersonalCertificationDetailResponse>({
    url: '/subjects/personal/certification',
    method: 'get',
  });
}

/**
 * POST 提交个人认证
 *
 * HTTP 接口: POST /subjects/personal/certification
 * 说明: 提交真实姓名、证件号码、证件类型、联系人姓名、联系人手机号及证件正反面照片资源进行个人实名认证。
 *
 * @param {Api.PersonalCertification.SubmitPersonalCertificationRequest} data 提交个人认证的请求体参数 (partydto.SubmitPersonalCertificationRequest)
 * @returns {Promise<Api.PersonalCertification.CertificationSubmissionResponse>} 返回提交后生成的认证状态及主体标识 (partydto.CertificationSubmissionResponse)
 */
export function fetchSubmitPersonalCertification(
  data: Api.PersonalCertification.SubmitPersonalCertificationRequest
) {
  return request<Api.PersonalCertification.CertificationSubmissionResponse>({
    url: '/subjects/personal/certification',
    method: 'post',
    data,
  });
}
